import React, { Component, Fragment } from 'react';
import { Navigationmenu } from '../components';
import CircularProgress from '@material-ui/core/CircularProgress';
import CDDCRM from '../userinterface/CDDCRM';
import SEARCHPAGE from '../userinterface/SearchPage';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
    Box,
    Button,
    Typography,
    Grid,
    TextField,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Popover,
    Dialog,
    Tabs,
    Tab,
    Checkbox,
    DialogActions,
    withStyles,
    Divider
} from '@material-ui/core';
import {
    SearchOutlined,
    ArrowDropDown,
    Publish,
    NoteAdd,
    ArrowDropUp,
    InsertDriveFileOutlined,
    Today
} from '@material-ui/icons';
import {
    ALTERNATEROW_BACKGROUND_COLOR,
    BLUE_COLOR, LIGHTGRAY_COLOR,
    MODIFIEDBLACK,
    PINK_COLOR,
    PROTECT_GREEN,
    RED_COLOR,
    VIBRANT_GREEN
} from "../constants";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from 'render-if';
import axios from "axios";
import { Redirect } from "react-router-dom";
import { indigo } from '@material-ui/core/colors';
import SearchPage from '../userinterface/SearchPage';
import ArchiveDMS from '../userinterface/ArchiveDMS';
import { fnPostapiResponse, fnGETapiResponse } from '../APICall';


const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        backgroundColor: 'white',
        height: 3
    },
}, { index: 1 })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: 'white',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        '&:focus': {
            opacity: 1
        }
    },
}, { index: 1 }))((props) => <Tab disableRipple {...props} />);

export default class CMS extends Component {

    state = {
        CMSPhiden: "",
        CMSTitle: "",
        CMSPreSufix: "",
        CMSCRMId: "",
        CMSLEADId: "",
        CMSchkPermanent: false,
        CMSSurname: "",
        CMSchkDpaflag: "",
        CMSForename: "",
        CMSMaidenname: "",
        CMSchkAgeAdmitted: "",
        CMSTelephoneHome: "",
        CMSTelephoneoffice: "",
        CMSTelephoneMobile: "",
        currentdate: "",
        CMSEmail: "",
        CMSAddress1: "",
        CMSAddress2: "",
        CMSAddress3: "",
        CMSAddress4: "",
        CMSAddress5: "",
        CMSAddressCode: "",
        CMSRegionCode: "",
        CMSPostalCode: "",
        CMSchkAliasIndicator: true,
        CMSAliasSurname: "",
        CMSAliasForename: "",
        CMSchkDoNotShare: false,
        CMSchkAgent: false,
        CMSchkSwanCompany: false,
        CMSchkUndeliverd: false,
        CmsClientType: [],
        CmsClientSubType: [],
        CmsSex: [],
        CmsStatescdGroup: [],
        CmsMartialStatus: [],
        CmsNicCountry: [],
        CmsIdnumber: [],
        CmsPreferdComMode: [],
        CmsselectedClientType: "",
        CmsselectedClientSubType: "",
        CmsselectedSex: "",
        CmsselectedStatescdGroup: "",
        CmsselectedMartialStatus: "",
        CmsselectedNicCountry: "",
        CmsselectedIdnumber: "",
        CmsselectedPreferdComMode: "",
        CmsuserInit: "",
        expanded: false,
        policynum: "policy type",
        period: "all",
        status: "all",
        anchorEl: null,
        open: false,
        ishovered: false,
        hoverindex: 0,
        showDialog: false,
        tabsvalue: 0,
        addpolicyholder: false,
        editinfo: false,
        tablebuffer: [],
        pages: 0,
        current: 1,
        records: 0,
        pageSize: 10,
        showPager: false,
        SOURCE: "",
        FNAME: "",
        SNAME: "",
        NIC: "",
        DBUserName: "",
        DBPassword: "",
        DBSource: "",
        DBProvider: "",
        test: true,
        isloading: false,
        pagesObj: [],
        isAddnewItem: false,
        isLoadExisting: true,
        disableTabs: "",
        selectedPass: "",
        ClientType: [],
        CompanyType: [],
        NATIONALITY: [],
        GENDER: [],
        country: [],
        SelectedClientType: "",
        SelectedCompany: '',
        SelectedClientName: "",
        selectedPassDROP: "",
        ispassdrp: false,
        isclntIndv: false,
        lblnationality: "",
        amlgender: "M",
        selectedOption: true,
        caseid: "",
        selectedCountry: "",
        selectedPAssCountry: "MUS",
    }

    componentDidMount() {
        var date = new Date()
        this.state.currentdate = date.getFullYear() + "" + (date.getMonth() + 1)
        var data1 = {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GETCMS',
            "MAPIPORT": '' + process.env.REACT_APP_MPORT + '',
            "body": ''
        }
        fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data1, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var data = response.data
            this.setState({
                CmsClientType: data["catagory"][0],
                CmsSex: data["Gender"][0],
                CmsNicCountry: data["Country"][0],
                CmsStatescdGroup: data["EthnicGroup"][0],
                CmsIdnumber: data["IDNumber"][0],
                CmsMartialStatus: data["maritialStatus"][0],
                //CmsuserInit:data["getUserInitial"][0][0]["USER_INITI"]
            });
        }).catch(e => console.log(e))
        this.getcmp()
    }
    FntocheckClienttype(value, Company) {
        if (value == "INDIVIDUAL") {
            this.setState({ lblnationality: "NATIONALITY", isclntIndv: false, amlgender: "M", SNAMElabel: "SURNAME", displayastric: "block", isforeignSwitchChecked: false, displayForeign: "none", ispassdrp: false })
        }
        else {
            this.setState({ lblnationality: "Country of Incorporation", isclntIndv: true, amlgender: "O", SNAMElabel: "COMPANY NAME", displayastric: "none", isforeignSwitchChecked: false, displayForeign: "block", ispassdrp: false })
        }
        this.fnsetclientType(value)
        //     this.FntocheckpassDrop(this.state.selectedPassDROP, this.state.NIC, this.state.selectedCountry)
        //     // alert(this.state.caseid)
        //     this.setState({
        //        nicvaliderror: ""
        //    })

        //    if (this.state.selectedPassDROP == "NIC") {
        //        alert(this.Nicchecking(this.state.caseid))
        //        this.Nicchecking(this.state.caseid)
        //        }
    }

    getcmp() {

        var data = {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GETAMLDETAILS',
            "MAPIPORT": '' + process.env.REACT_APP_MPORT + '',
            "body": ''
        }
        // console.log(data)
        fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var data = response.data
            console.log(data)
            var cttype = sessionStorage.getItem('ClientType')
            if (cttype != "") {
                cttype = sessionStorage.getItem('ClientType').toUpperCase().trim()
                var Companytype = sessionStorage.getItem('Company').toUpperCase().trim()
                this.setState({
                    CompanyType: data["Company"][0],
                    ClientType: data["ClientType"][0],
                    country: data["Country"][0],
                    NATIONALITY: data["NATIONALITY"][0],
                    GENDER: data["Gender"][0],
                    SelectedCompany: Companytype,
                    SelectedClientType: cttype,
                });
                // this.fnsetclientType(this.state.SelectedClientType)
                this.FntocheckClienttype(cttype, Companytype)
                this.fnsetdatafromtheurl()
                this.setState({ SelectedCompany: Companytype })
            }
            else {
                this.setState({
                    CompanyType: data["Company"][0],
                    ClientType: data["ClientType"][0],
                    country: data["Country"][0],
                    GENDER: data["Gender"][0],
                    SelectedCompany: "SWAN GENERAL",
                    SelectedClientType: "CORPORATE",
                    lblnationality: "COUNTRY",
                    isclntIndv: true,
                    amlgender: "O",
                    SNAMElabel: "COMPANY NAME"
                });
                this.state.pageloadingdata = 1
                this.fnsetclientType(this.state.SelectedClientType)
            }

        }).catch(e => console.log(e));
    }
    fnsetclientType(clnttype) {
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GETNICBRN',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": clnttype
        }
        fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            this.setState({ NATIONALITY: response.data["nicbrnval"][0] })
            //  console.log(this.state.NATIONALITY)
            if (this.state.pageloadingdata == 1) {
                if (
                    clnttype == "CORPORATE"
                )
                    this.setState({
                        NICselectedlabel: "Business Registration Number",
                        selectedPassDROP: "BRN"
                    })
                else {
                    this.setState({
                        NICselectedlabel: "National Identity Card",
                        selectedPassDROP: "NIC"
                    })
                }
            }
            else {
                this.FntocheckpassDrop(this.state.selectedPassDROP, this.state.NIC, this.state.selectedPAssCountry)
                this.setState({
                    pageloadingdata: 1
                })
            }
            // this.fnsetdatafromtheurl()
            // this.state.pageloadingdata = 2



        }).catch(e => console.log(e));
    }
    FntocheckpassDrop(pasdrp, nic, country) {


        var flist = this.state.NATIONALITY.filter((list) => list.GRP_VALUES === pasdrp);

        this.setState({ NICselectedlabel: flist[0]["DESC50"] })
        if (nic == "") {
            this.setState({ caseid: "" })
        }

        if (nic == null)
            nic = ""
        if (pasdrp == "PAS" || pasdrp == "LEI" || pasdrp == "CRN") {
            // if (pasdrp == "PAS")
            this.setState({ ispassdrp: true })
            var caseId = pasdrp + "-" + nic + "-" + country.slice(0, 3)
            this.state.caseid = caseId
            this.setState({ caseid: caseId })
        }
        else {
            this.setState({ ispassdrp: false })
            var caseId = pasdrp + "-" + nic
            this.state.caseid = caseId
            this.setState({ caseid: caseId })

        }

        // alert(this.state.caseid)

    }
    handleswitchchange(e, country) {
        if (this.state.SelectedClientType == "CORPORATE") {
            if (e && country != "MUS") {
                // debugger
                this.setState({
                    isdisplayswitch: "block", isforeignSwitchChecked: true,
                    NATIONALITY: [
                        {
                            "GRP_VALUES": "LEI",
                            "DESC50": "Legal entity identifier",
                            "ORDERING": "100",
                            "GRP_VALUE1": "CORPORATE"
                        },
                        {
                            "GRP_VALUES": "CRN",
                            "DESC50": "Company registration number",
                            "ORDERING": "120",
                            "GRP_VALUE1": "CORPORATE"
                        }

                    ], NICselectedlabel: "Legal entity identifier",
                    selectedPassDROP: "LEI", ispassdrp: true
                });
            } else {
                this.setState({ isdisplayswitch: "block", isforeignSwitchChecked: false, ispassdrp: false });
                this.FntocheckClienttype(this.state.SelectedClientType, this.state.SelectedCompany)
            }
        }
    }
    handeltextChange(e, key) {
        this.setState({ key: e.target.value });
        this.state[key] = e.target.value;
    }
    SaveCMSClick() {
        // POST request using fetch with error handling
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'POSTCMS',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                "phidenNo": "" + this.state.CMSPhiden + "",
                "CLientFlag": "" + this.state.CMSchkDpaflag + "",
                "Surname": "" + this.state.CMSSurname + "",
                "Forenames": "" + this.state.CMSForename + "",
                "title": "" + this.state.CMSTitle + "",
                "AltSurname": "" + this.state.CMSAliasSurname + "",
                "AltForenames": "" + this.state.CMSAliasForename + "",
                "MaidenName": "" + this.state.CMSMaidenname + "",
                "Sex": "" + this.state.CmsselectedSex + "",
                "MaritalStatus": "" + this.state.CmsselectedMartialStatus + "",
                "EthnicGrp": "" + this.state.CmsselectedStatescdGroup + "",
                "Address": "" + this.state.CMSAddress1 + "" + this.state.CMSAddress2 + "" + this.state.CMSAddress3 + "" + this.state.CMSAddress4 + "" +
                    this.state.CMSAddress5 + "",
                "TelHome": "" + this.state.CMSTelephoneHome + "",
                "TelOffice": "" + this.state.CMSTelephoneoffice + "",
                "PlaceBirth": "" + this.state.CmsselectedNicCountry + "",
                "DoB": "19930604",
                "AgeNxtBirth": "" + 27 + "",
                "AgeAdmitted": "" + this.state.CMSchkAgeAdmitted + "",
                "Occupation": "",
                "MedReq": "",
                "UserInit": "" + this.state.CmsuserInit + "",
                "date": "" + this.state.currentdate + "",
                "RegCode": "" + this.state.CMSRegionCode + "",
                "TelMobile": "" + this.state.CMSTelephoneMobile + "",
                "NICCountry": "" + this.state.CmsselectedNicCountry + "",
                "NIC": "",
                "AddExt": "",
                "EmailExt": "",
                "Filler": "",
                "Email1": "" + this.state.CMSEmail + "",
                "Email2": "",
                "LenofSurvice": "",
                "Industry": "",
                "PostalCode": "" + this.state.CMSPostalCode + "",
                "TitleStatus": "" + this.state.CMSPreSufix + "",
                "AddCode": "" + this.state.CMSAddressCode + "",
                "cboCommMode": "" + this.state.CmsPreferdComMode + "",
                "PrivAgent": "",
                "PrivSwan": "",
                "USCitizen": "",
                "USPassport": "",
                "EUCitizen": "",
                "EUPassport": "",
                "CRMID": "" + this.state.CMSCRMId + "",
                "KYCDoneBy": "",
                "KYCDoneByDate": "",
                "KYCUpdatedBy": "",
                "KYCUpdatedByDate": "",
                "KYCStatus": "",
                "ClntCat": "" + this.state.CmsselectedClientType + "",
                "SubClntCat": "" + this.state.CmsselectedClientSubType + "",
                "LeadID": "" + this.state.CMSLEADId + "",
            }
        };
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'PostApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
        }).catch(e => console.log(e));
    }
    handleClick(event) {
        this.setState({ anchorEl: event.currentTarget, open: !this.state.open });
    };
    handlereset(e) {
        var r = window.confirm("Do you want to Clear ?")
        var date = new Date()
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
        var date1 = date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()
        var CMLSELECTEDATE = date.getFullYear() + "-" + month + "-" + date1
        if (r == true) {
            this.setState({
                NIC: "",
                SNAME: "",
                FNAME: "",
                amlgender: "o",
                DOB: CMLSELECTEDATE,
                SelectedCompany: "SWAN GENERAL",
                SelectedClientName: "",
                SelectedClientType: "CORPORATE", selectedCountry: "",
                selectedPassDROP: "NIC",
                tablebuffer: [],
                pagesObj: [],
                ispassdrp: false, isforeignSwitchChecked: false,
                displayForeign: "block",
                displaygorbmbutton: 'none'
            })
            this.FntocheckClienttype("CORPORATE", "SWAN GENERAL")
            // this.FntocheckpassDrop("BRN", "", "")
            //window.close()
        }
    }
    handleSerachChange(e, key) {
        this.setState({ key: e.target.value });
        this.state[key] = e.target.value;
    }
    handlefocusout(e) {
        this.FntocheckpassDrop(this.state.selectedPassDROP, e.target.value, this.state.selectedPAssCountry)
    }
    handleClose() {
        this.setState({ anchorEl: null, open: !this.state.open, addpolicyholder: true });
    };

    handleChangeTabs(value) {
        this.setState({ tabsvalue: value });
        // alert(this.state.tabsvalue)
    }
    FntoSetsubtypes(e) {
        var data1 =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GETClientSubType',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": e
        }
        fnGETapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'GetApiMiddleWare', data1, process.env.REACT_APP_PORT_MIDDLEWARE).then((response2) => {
            this.setState({
                CmsClientSubType: response2.data[0]
            });
        }).catch(e => console.log(e));
    }
    setCrmOpration(e) {
        if (e == "AddNew") {
            this.setState({
                isAddnewItem: true,
                isLoadExisting: false,
                disableTabs: 'none'
            })
        }
        else {
            this.setState({
                isAddnewItem: false,
                isLoadExisting: true,
                disableTabs: ''
            })
        }
    }

    render() {
        return (
            <Fragment>
                <Navigationmenu selectedMenu={'CMS'} />
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{ marginTop: 35 }}
                >
                    <Paper elevation={2} style={{ minHeight: 100, width: '90%', borderRadius: 6 }}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center">
                            <div style={{ minHeight: 100, width: '98%', borderRadius: 6 }}>
                                <Box
                                    display="flex"
                                    style={{ marginTop: '4vh' }}
                                    alignItems="center"
                                    justifyContent="center">
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <div style={{ display: 'flex', marginBottom: 20 }}>
                                                <Typography style={{ borderWidth: 0, color: BLUE_COLOR, fontFamily: 'Globerbold', fontSize: 30, paddingLeft: 10 }}>Client Maintenance</Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            {/* <Button variant={'text'} onClick={() => this.setState({ showDialog: true })}
                                                style={{ color: 'white', float: 'Right', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '30%', fontSize: 18 }}>
                                                AML Watchlist
                                            </Button> */}
                                        </Grid>

                                        <Grid item xs={12}>
                                            <RadioGroup row aria-label="" name="v" >
                                                <FormControlLabel value="ViewExisting" onClick={e => this.setCrmOpration(e.target.value)} checked={this.state.isLoadExisting} control={<Radio color={BLUE_COLOR} />} label="Load existing" />
                                                <FormControlLabel value="AddNew" onClick={e => this.setCrmOpration(e.target.value)} checked={this.state.isAddnewItem} control={<Radio color={BLUE_COLOR} />} label="Add new" />
                                            </RadioGroup>
                                        </Grid>
                                        <div style={{ display: this.state.disableTabs, width: '100%', marginBottom: 30, marginLeft: 20 }}>
                                            <Grid container spacing={2} style={{ marginBottom: 30 }}>
                                                <Grid item xs={1} style={{ fontSize: "15px", fontFamily: 'Globerbold', color: BLUE_COLOR }}  >
                                                    COMPANY
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Select fullWidth
                                                        variant={'outlined'}
                                                        value={this.state.SelectedCompany}
                                                        onChange={e => this.setState({ SelectedCompany: e.target.value }
                                                            , this.FntocheckClienttype(this.state.SelectedClientType, e.target.value))
                                                        }

                                                    >
                                                        {this.state.CompanyType.map(team => (
                                                            <MenuItem value={team.COMPANY}>{team.COMPANY}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </Grid>
                                                <Grid item xs={1} style={{ marginLeft: "10px", fontSize: "15px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                    CLIENT TYPE</Grid>
                                                <Grid item xs={3}>
                                                    <Select fullWidth
                                                        variant={'outlined'}
                                                        value={this.state.SelectedClientType}
                                                        onChange={e => this.setState({ SelectedClientType: e.target.value },
                                                            this.FntocheckClienttype(e.target.value, this.state.SelectedCompany))}

                                                    >
                                                        {this.state.ClientType.map(team => (
                                                            <MenuItem value={team.CLIENTTYPE}>{team.CLIENTTYPE}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </Grid>
                                                <Grid item xs={3} style={{ marginLeft: "30px" }}>
                                                    <TextField fullWidth label="CLIENT NUMBER" value={this.state.SelectedClientName}
                                                        onChange={(e) => this.handleSerachChange(e, "SelectedClientName")}
                                                        InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                        InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={3} style={{ marginBottom: 30 }}>
                                                <Grid item xs={2}>
                                                    <FormControl fullWidth >
                                                        <TextField label={this.state.SNAMElabel}
                                                            value={this.state.SNAME}
                                                            onChange={(e) => this.handleSerachChange(e, "SNAME")}
                                                            onBlur={e => this.setState({ SNAME: e.target.value.substring(0, 50) })}
                                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <FormControl fullWidth>
                                                        <TextField disabled={this.state.isclntIndv} label="FIRST NAME" style={{ width: '100%', marginLeft: '10px' }}
                                                            value={this.state.FNAME}
                                                            onChange={(e) => this.handleSerachChange(e, "FNAME")}
                                                            InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={1} style={{ fontSize: "16px", marginLeft: "20px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>
                                                    {this.state.lblnationality}
                                                </Grid>
                                                <Grid item xs={2}>

                                                    <Select fullWidth
                                                        variant={'outlined'}
                                                        value={this.state.selectedCountry}
                                                        onChange={e => this.setState({ selectedCountry: e.target.value }
                                                            , this.handleswitchchange(true, e.target.value))}
                                                    >
                                                        {this.state.country.map(team => (
                                                            <MenuItem value={team.CODE}>{team.DESCRIPTION}</MenuItem>
                                                        ))}
                                                    </Select>             </Grid>

                                                <Grid item xs={1}>

                                                    <Select style={{ marginLeft: '-20px', width: '96px' }}
                                                        variant={'outlined'}
                                                        value={this.state.selectedPassDROP}
                                                        onChange={e => this.setState({
                                                            selectedPassDROP: e.target.value
                                                        },
                                                            this.FntocheckpassDrop(e.target.value, this.state.NIC, this.state.selectedPAssCountry))}
                                                    >
                                                        {this.state.NATIONALITY.map(team => (
                                                            <MenuItem value={team.GRP_VALUES}>{team.GRP_VALUES}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <TextField
                                                        style={{ marginLeft: '20px', width: '100%' }}
                                                        label={this.state.NICselectedlabel} value={this.state.NIC}
                                                        onChange={(e) => this.handleSerachChange(e, "NIC")}
                                                        onBlur={(e) => this.handlefocusout(e, "NIC")} InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                        InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                </Grid>

                                                {/* <label style={{color:DARKGREEN_COLOR,fontSize:20}}>*</label> */}
                                            </Grid>
                                            {/*FILTER DROPDOWNS*/}

                                            <Grid container spacing={2}>

                                                {/* <Grid style={{ display: this.state.ispassdrp ? "" : "none" }} item xs={2}>
                                                <Select fullWidth
                                                    variant={'outlined'}
                                                    value={this.state.selectedPAssCountry}
                                                    onChange={e => this.setState({ selectedPAssCountry: e.target.value },

                                                        this.FntocheckpassDrop(this.state.selectedPassDROP, this.state.NIC, e.target.value))}
                                                >
                                                    {this.state.country.map(team => (
                                                        <MenuItem value={team.CODE}>{team.DESCRIPTION}</MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>
                                            <Grid style={{ display: 'none' }}>
                                                <TextField fullWidth label="CASE ID" disabled
                                                    value={this.state.caseid}
                                                    onChange={(e) => this.handleSerachChange(e, "caseid")} variant="outlined"
                                                />
                                            </Grid> */}
                                                <Grid item xs={9}></Grid>
                                                <Grid style={{ display: "flex", justify: "flex-end" }} item xs={3}>

                                                    <Button variant={'text'} style={{ color: 'white', marginLeft: 50, fontFamily: 'Globerbold', backgroundColor: VIBRANT_GREEN, width: '30%', fontSize: 18 }}>
                                                        SEARCH
                                                    </Button>

                                                    {/* <Button variant={'text'} onClick={(e) => this.RefinitiveresponseandAML("FULL")} style={{ color: 'white', marginLeft: '2px', display: this.state.isDisplayFullButton, fontFamily: 'Globerbold', backgroundColor: RED_COLOR, width: '30%', fontSize: 18 }}>
                                            FULL
                                        </Button> */}
                                                    <Button variant={'text'} onClick={(e) => this.handlereset(e)} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "2px", backgroundColor: BLUE_COLOR, width: '30%', fontSize: 18 }}>
                                                        CLEAR
                                                    </Button>
                                                    {/* <Button variant={'text'} onClick={(e) => this.rbmButtonClick()} style={{ color: 'white', display: this.state.displaygorbmbutton, marginLeft: '2px', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '30%', fontSize: 18 }}>
                                            Go RBM
                                        </Button> */}
                                                </Grid>

                                            </Grid>
                                        </div>
                                    </Grid>
                                </Box>
                                <StyledTabs variant="fullWidth"
                                    aria-label="disabled tabs example"
                                    style={{ backgroundColor: BLUE_COLOR }}
                                    value={this.state.tabsvalue}
                                    onChange={(e, i) => this.handleChangeTabs(i)}>
                                    <StyledTab fullWidth style={{ fontFamily: 'Globerbold', fontSize: 18 }} label="Personal Details" />
                                    <StyledTab fullWidth style={{ fontFamily: 'Globerbold', fontSize: 18 }} label="AML" />
                                    <StyledTab fullWidth style={{ fontFamily: 'Globerbold', fontSize: 18 }} label="RBM" />
                                    <StyledTab fullWidth style={{ fontFamily: 'Globerbold', fontSize: 18 }} label="CDD" />
                                    <StyledTab fullWidth style={{ fontFamily: 'Globerbold', fontSize: 18 }} label="Archived DMS" />
                                </StyledTabs>
                                {
                                    renderIf(this.state.tabsvalue == 0)(
                                        <div style={{ width: '100%', backgroundColor: 'rgba(248,248,248,1.0)' }}>
                                            <Box display="flex"
                                                alignItems="center"
                                                justifyContent="center">
                                                <div style={{ width: '96%' }}>
                                                    <Grid container spacing={2} style={{ marginTop: 10, marginBottom: 10 }}>
                                                        <Grid item xs style={{ flexDirection: 'column' }}>
                                                            <Typography style={{ fontFamily: "Globerbold", color: MODIFIEDBLACK, fontSize: 16 }}>
                                                                <FormControl fullWidth>
                                                                    <TextField label="Phiden" style={{ width: '10%' }}
                                                                        value={this.state.CMSPhiden}
                                                                        onChange={(e) => this.handeltextChange(e, "CMSPhiden")}
                                                                        InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                        InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                                </FormControl>
                                                            </Typography>
                                                        </Grid>
                                                        {/* <Grid item xs>
                                                            Client Type :
                                                        </Grid>
                                                        <Grid item xs >
                                                            <Select fullWidth 
                                                                variant={'outlined'}
                                                                value={this.state.CmsselectedClientType}
                                                                onChange={e=>this.setState({CmsselectedClientType:e.target.value },this.FntoSetsubtypes(e.target.value))}>
                                                                {this.state.CmsClientType.map(select => (
                                                                <MenuItem key={select.CODE} value={select.CODE}>{select.TYPE}</MenuItem>))}
                                                            </Select>
                                                        </Grid>
                                                        <Grid item xs>
                                                            Client Sub Type :
                                                        </Grid>
                                                        <Grid item xs >
                                                            <Select fullWidth 
                                                                variant={'outlined'}
                                                                value={this.state.CmsselectedClientSubType}
                                                                onChange={e=>this.setState({CmsselectedClientSubType:e.target.value })}>
                                                                {this.state.CmsClientSubType.map(select => (
                                                                <MenuItem key={select.CODE} value={select.CODE}>{select.TYPE}</MenuItem>))}
                                                            </Select>
                                                        </Grid>
                                                     */}
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs style={{ flexDirection: 'column' }}>
                                                            <Typography style={{ fontFamily: "Globerbold", color: MODIFIEDBLACK, fontSize: 16 }}>
                                                                <TextField label="Title"
                                                                    value={this.state.CMSTitle}
                                                                    onChange={(e) => this.handeltextChange(e, "CMSTitle")}
                                                                    style={{ width: '100%' }}
                                                                    InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                    InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="Prefix/Suffix(P/S):"
                                                                value={this.state.CMSPreSufix}
                                                                onChange={(e) => this.handeltextChange(e, "CMSPreSufix")}
                                                                style={{ width: '10%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="CRM ID:"
                                                                value={this.state.CMSCRMId}
                                                                onChange={(e) => this.handeltextChange(e, "CMSCRMId")}
                                                                style={{ width: '100%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="LEAD ID:"
                                                                value={this.state.CMSLEADId}
                                                                onChange={(e) => this.handeltextChange(e, "CMSLEADId")}
                                                                style={{ width: '100%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Checkbox name="chkPermanent" color="primary" value={this.state.CMSchkPermanent} />
                                                            Permanent
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs style={{ flexDirection: 'column' }}>
                                                            <Grid item xs>
                                                                <TextField label="Surname:"
                                                                    value={this.state.CMSSurname}
                                                                    onChange={(e) => this.handeltextChange(e, "CMSSurname")}
                                                                    style={{ width: '100%' }}
                                                                    InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                    InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs></Grid>
                                                        <Grid item xs>
                                                            <Checkbox name="chkDPaFlag" color="primary" value={this.state.CMSchkDpaflag} />
                                                            DPA Flag
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs={6} style={{ flexDirection: 'column' }}>
                                                            <Grid item xs>
                                                                <TextField label="Forenames:"
                                                                    value={this.state.CMSForename}
                                                                    onChange={(e) => this.handeltextChange(e, "CMSForename")}
                                                                    style={{ width: '100%' }}
                                                                    InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                    InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs={1}>
                                                            Sex :
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <Select fullWidth
                                                                variant={'outlined'}
                                                                value={this.state.CmsselectedSex}
                                                                onChange={e => this.setState({ CmsselectedSex: e.target.value })}>
                                                                {this.state.CmsSex.map(select => (
                                                                    <MenuItem key={select.CODE} value={select.CODE}>{select.TYPE}</MenuItem>))}
                                                            </Select>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="Maiden Name:"
                                                                value={this.state.CMSMaidenname}
                                                                onChange={(e) => this.handeltextChange(e, "CMSMaidenname")}
                                                                style={{ width: '100%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs={2}>
                                                            <TextField
                                                                id="date"
                                                                label="Date Of Birth"
                                                                type="date"
                                                                valuealue={this.state.currentdate.toString()}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }} />
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            Age Admitted(Y/N)
                                                            <Checkbox name="chkAgeadmitted" color="primary" value={this.state.CMSchkAgeAdmitted} />
                                                        </Grid>
                                                        {/* <Grid item xs={1}>
                                                        Stats Cd Group :
                                                    </Grid>
                                                    <Grid item xs>
                                                        <Select fullWidth 
                                                            variant={'outlined'}
                                                            value={this.state.CmsselectedStatescdGroup}
                                                            onChange={e=>this.setState({CmsselectedStatescdGroup:e.target.value })}>
                                                            {this.state.CmsStatescdGroup.map(select => (
                                                            <MenuItem key={select.CODE} value={select.CODE}>{select.TYPE}</MenuItem>))}
                                                        </Select>
                                                    </Grid> */}
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs={1}>
                                                            Marital Status :
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <Select fullWidth
                                                                variant={'outlined'}
                                                                value={this.state.CmsselectedMartialStatus}
                                                                onChange={e => this.setState({ CmsselectedMartialStatus: e.target.value })}>
                                                                {this.state.CmsMartialStatus.map(select => (
                                                                    <MenuItem key={select.CODE} value={select.CODE}>{select.TYPE}</MenuItem>))}
                                                            </Select>
                                                        </Grid>
                                                        <Grid item xs={1}>
                                                            Nic Country:
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Select fullWidth
                                                                variant={'outlined'}
                                                                value={this.state.CmsselectedNicCountry}
                                                                onChange={e => this.setState({ CmsselectedNicCountry: e.target.value })}>
                                                                {this.state.CmsNicCountry.map(select => (
                                                                    <MenuItem key={select.CODE} value={select.CODE}>{select.TYPE}</MenuItem>))}
                                                            </Select>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Select fullWidth
                                                                variant={'outlined'}
                                                                value={this.state.CmsselectedIdnumber}
                                                                onChange={e => this.setState({ CmsselectedIdnumber: e.target.value })}>
                                                                {this.state.CmsIdnumber.map(select => (
                                                                    <MenuItem key={select.CODE} value={select.CODE}>{select.TYPE}</MenuItem>))}
                                                            </Select>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="" style={{ width: '100%' }}
                                                                value={""}
                                                                onChange={(e) => this.handeltextChange(e, "")}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />

                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs>
                                                            <TextField label="Telephone Home:"
                                                                value={this.state.CMSTelephoneHome}
                                                                onChange={(e) => this.handeltextChange(e, "CMSTelephoneHome")}
                                                                style={{ width: '100%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="Telephone Office:"
                                                                value={this.state.CMSTelephoneoffice}
                                                                onChange={(e) => this.handeltextChange(e, "CMSTelephoneoffice")}
                                                                style={{ width: '100%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="Telephone Mobile:"
                                                                value={this.state.CMSTelephoneMobile}
                                                                onChange={(e) => this.handeltextChange(e, "CMSTelephoneMobile")}
                                                                style={{ width: '100%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs={6} style={{ flexDirection: 'column' }}>
                                                            <Grid item xs>
                                                                <TextField label="Email:"
                                                                    value={this.state.CMSEmail}
                                                                    onChange={(e) => this.handeltextChange(e, "CMSEmail")}
                                                                    style={{ width: '100%' }}
                                                                    InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                    InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs={6} style={{ flexDirection: 'column' }}>
                                                            <Grid item xs>
                                                                <TextField label="Address (1):"
                                                                    value={this.state.CMSAddress1}
                                                                    onChange={(e) => this.handeltextChange(e, "CMSAddress1")}
                                                                    style={{ width: '100%' }}
                                                                    InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                    InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="Address (2):"
                                                                value={this.state.CMSAddress2}
                                                                onChange={(e) => this.handeltextChange(e, "CMSAddress2")}
                                                                style={{ width: '100%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs style={{ flexDirection: 'column' }}>
                                                            <Grid item xs>
                                                                <TextField label="Address (3):"
                                                                    value={this.state.CMSAddress3}
                                                                    onChange={(e) => this.handeltextChange(e, "CMSAddress3")}
                                                                    style={{ width: '100%' }}
                                                                    InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                    InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="Address(4):"
                                                                value={this.state.CMSAddress4}
                                                                onChange={(e) => this.handeltextChange(e, "CMSAddress4")}
                                                                style={{ width: '100%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs={6} style={{ flexDirection: 'column' }}>
                                                            <Grid item>
                                                                <TextField label="Address (5):"
                                                                    value={this.state.CMSAddress5}
                                                                    onChange={(e) => this.handeltextChange(e, "CMSAddress5")}
                                                                    style={{ width: '100%' }}
                                                                    InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                    InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="Address code:"
                                                                value={this.state.CMSAddressCode}
                                                                onChange={(e) => this.handeltextChange(e, "CMSAddressCode")}
                                                                style={{ width: '18%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        {/* <Grid item xs>
                                                        <TextField label="Region Code:" 
                                                            value={this.state.CMSRegionCode}
                                                            onChange={(e)=>this.handeltextChange(e,"CMSRegionCode")}
                                                            style={{width: '100%'}}
                                                            InputProps={{style: {fontFamily: 'Globerbold', color: MODIFIEDBLACK}}}
                                                            InputLabelProps={{style: {fontFamily: 'Globerbold', color: BLUE_COLOR}}}/>
                                                    </Grid> */}
                                                        <Grid item xs={2}> Region/ Postal code:</Grid>

                                                        <Grid item xs>
                                                            <Select fullWidth
                                                                variant={'outlined'}
                                                                value={this.state.CMSPostalCode}
                                                                onChange={e => this.setState({ CMSPostalCode: e.target.value })}>
                                                                <MenuItem value="Email"></MenuItem>
                                                                {/* <MenuItem value="Post">Post</MenuItem>
                                            <MenuItem value="Phone">Phone</MenuItem>
                                            <MenuItem value="SMS">SMS</MenuItem> */}
                                                            </Select>
                                                        </Grid>
                                                        <Grid item xs>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs>
                                                            <Checkbox name="aliasIndicator" color="primary" checked={true} value={this.state.CMSchkAliasIndicator} /> Alias Indicator
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="Alias Surname:"
                                                                value={this.state.CMSAliasSurname}
                                                                onChange={(e) => this.handeltextChange(e, "CMSAliasSurname")}
                                                                style={{ width: '100%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                        <Grid item xs>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <TextField label="Alias Forenames:"
                                                                value={this.state.CMSAliasForename}
                                                                onChange={(e) => this.handeltextChange(e, "CMSAliasForename")}
                                                                style={{ width: '100%' }}
                                                                InputProps={{ style: { fontFamily: 'Globerbold', color: MODIFIEDBLACK } }}
                                                                InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }} />
                                                        </Grid>
                                                        <Grid item xs>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                                                        <Grid item xs={2}> Preferred Communication Mode:</Grid>
                                                        <Grid item xs={2}>
                                                            <Select fullWidth
                                                                variant={'outlined'}
                                                                value={this.state.CmsselectedPreferdComMode}
                                                                onChange={e => this.setState({ CmsselectedPreferdComMode: e.target.value })}>
                                                                <MenuItem value="Email">Email</MenuItem>
                                                                <MenuItem value="Post">Post</MenuItem>
                                                                <MenuItem value="Phone">Phone</MenuItem>
                                                                <MenuItem value="SMS">SMS</MenuItem>
                                                            </Select>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Checkbox name="chkdoNotShare" color="primary" value={this.state.CMSchkDoNotShare} />
                                                            Do not Share Data
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Checkbox name="chkAgent" color="primary" value={this.state.CMSchkAgent} />
                                                            Agent
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Checkbox name="chkswancompany" color="primary" value={this.state.CMSchkSwanCompany} />
                                                            Swan Company
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Checkbox name="chkUndeliverd" color="primary" value={this.state.CMSchkUndeliverd} />
                                                            Undelivered
                                                        </Grid>
                                                    </Grid>
                                                    <Divider></Divider>
                                                    <br></br>

                                                    <Grid container spacing={2}>
                                                        <Grid item xs>
                                                            <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '135px' }}>
                                                                Add New Client
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '135px' }}>
                                                                Clear
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '135px' }}>
                                                                Mearge Phiden
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Button variant={'text'} onClick={(e) => this.SaveCMSClick(e)} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '135px' }}>
                                                                Save
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '135px' }}>
                                                                Edit
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '135px' }}>
                                                                Permanent
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '135px' }}>
                                                                Cancel
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs>
                                                            <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '135px' }}>
                                                                Exit
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    <br></br>
                                                </div>
                                            </Box>
                                        </div>)
                                }
                                {
                                    renderIf(this.state.tabsvalue == 1)(
                                        <div style={{ width: '100%', backgroundColor: 'rgba(248,248,248,1.0)' }}>
                                            {/*AML WILL COME HERE */}
                                            <SearchPage></SearchPage>
                                        </div>)
                                }
                                {
                                    renderIf(this.state.tabsvalue == 2)(
                                        <div style={{ width: '100%', backgroundColor: 'rgba(248,248,248,1.0)' }}>
                                            {/*RBM STARTS*/}
                                            <CDDCRM></CDDCRM>
                                            {/*RBM ENDS*/}
                                        </div>)
                                }
                                {
                                    renderIf(this.state.tabsvalue == 4)(
                                        <div style={{ width: '100%', backgroundColor: 'rgba(248,248,248,1.0)' }}>
                                            {/*ArchiveDMS WILL COME HERE */}
                                            <ArchiveDMS></ArchiveDMS>
                                        </div>)
                                }
                                <div style={{ height: 40 }} />
                            </div>
                        </Box>

                    </Paper>
                </Box>
                <div style={{ height: 50 }} />
                <Dialog style={{ borderRadius: 0 }} maxWidth={'lg'} onClose={() => this.setState({ showDialog: false })} aria-labelledby="customized-dialog-title" open={this.state.showDialog}>
                    <SearchPage></SearchPage>
                </Dialog>
            </Fragment>
        )
    }
}